import { iif, Observable, of, pipe, throwError } from 'rxjs';
import { catchError, flatMap, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { UserLoginModel } from '../../shared/models/business-transaction/user-login.model';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { SystemNotificationService } from '../../shared/services/realtime-messaging/system-notification.service';
import { ReassignActiveWindow, ReassignmentData } from './modals/reassign-active-modal.component';
import { Directive } from '@angular/core';

@Directive()
export class AssignmentBase extends BaseComponent {
    WIP_STATUS_ACTIVE = 1;

    protected transaction: { 'businessTransactionNumberId': any; 'businessTransactionCategoryId': any } = { 'businessTransactionNumberId': '', 'businessTransactionCategoryId': '' };

    constructor(
        public modalService: MvdModalService,
        public _systemNotificationService: SystemNotificationService,
        public businessTransactionService: BusinessTransactionService
    ) {
        super();
    }

    ngOnInit() {}

    performAssignment(transactionNumber, status, recipient: UserLoginModel, originalUser: UserLoginModel, recipientUserId: number = null, setTransactionActive: boolean = false): Observable<any> {
        const recipientId = (recipient && recipient.id) ? recipient.id : recipientUserId;
        const originalUserId = originalUser ? +originalUser.id : null;
        const recipientUnchanged = recipient.id === originalUserId;
        const validationPipe = pipe(
            tap(() => this.clearValidation()),
            catchError(err => {
                this.handleValidationResult(err);
                return throwError(err);
            })
        );
        const notActiveStatus = status !== this.WIP_STATUS_ACTIVE;
        let assignmentObservable: Observable<any>;

        if (recipientUnchanged) {
            if (notActiveStatus && setTransactionActive) {
                assignmentObservable = this.businessTransactionService.activateTransactionForUser(transactionNumber, `${recipientId}`)
                    .pipe(validationPipe);
            } else {
                assignmentObservable = of(true);
            }
        } else if (notActiveStatus) {
            if (originalUser == null) {
                assignmentObservable = this.businessTransactionService.assignBusinessTransactionsToUser(transactionNumber, recipientId, setTransactionActive)
                    .pipe(validationPipe);
            } else {
                assignmentObservable = this.businessTransactionService.assignBusinessTransactionsToUser(transactionNumber, recipientId, setTransactionActive)
                    .pipe(validationPipe);
            }
        } else if (originalUser !== null) {
            const data = new ReassignmentData(transactionNumber, recipient, originalUser);
            assignmentObservable = this.modalService.open(ReassignActiveWindow, data).afterClosed()
                .pipe(
                    switchMap(result => iif(() => !!result, of(true), throwError(false))),
                    flatMap(() => this.businessTransactionService.assignBusinessTransactionsToUser(transactionNumber, recipientId, setTransactionActive)),
                    flatMap(() => this._systemNotificationService.dispatchSystemNotification(
                        [2], [originalUserId],
                        `${this.user.name} transferred this transaction to ${recipient.userName}, so you no longer can proceed with it at this point.`,
                        '/transaction/queues')
                    ));
        } else {
            assignmentObservable = this.businessTransactionService.assignBusinessTransactionsToUser(transactionNumber, recipientId, setTransactionActive)
                .pipe(validationPipe);
        }

        return assignmentObservable;
    }
}
